import React, { useRef } from 'react'
import "./Home_about_us.css"
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCirclePlay } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

function Home_about_us() {
    const videoRef = useRef(null);

    const handlePlayClick = () => {
        if (videoRef.current) {
            const video = videoRef.current;

            // Request fullscreen
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) { // Safari
                video.webkitRequestFullscreen();
            } else if (video.msRequestFullscreen) { // IE11
                video.msRequestFullscreen();
            }

            video.play(); // Play the video
        }
    };

    return (
        <section className='Home_about_us'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className='heading_holder'>
                            <h4>ABOUT US</h4>
                        </div>
                        <div className="text_holder">
                            <h3>Distributing FMCG Goods Across The Continent Of Africa</h3>
                            <p>
                               At Ayansh International Trading, we specialize in sourcing and distributing top-notch FMCG products across various categories including food and beverages, Wines & Spirits and more. With a keen focus on quality assurance, we partner with reputable manufacturers and brands globally to ensure that our customers receive nothing but the best. Driven by a passion for customer satisfaction, we strive to exceed expectations by offering an unparalleled level of service, reliability, and flexibility. Our experienced team is dedicated to understanding the unique requirements of each client and delivering tailored solutions that meet their specific needs efficiently and effectively. As a company based in the dynamic business hub of Dubai, UAE, we leverage our strategic location and extensive network to facilitate seamless trade operations in Africa.
                            </p>
                        </div>
                        <div className='btn_holder'>
                            <Link to="/about-us">
                                <Button className="know_more_btn">
                                    Know More About Us <FontAwesomeIcon className="arrow_icon" icon={faArrowRight} />
                                </Button>
                            </Link>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className='row'>
                            <div className="col-md-4 col-4 d-flex justify-content-center align-items-center">
                                <div className='vdo_holder'>
                                    <video
                                        ref={videoRef}
                                        className="about_us_vdo"
                                        src={process.env.PUBLIC_URL + "/assets/video/about_us/about_us.mp4"}
                                        muted
                                        loop
                                        alt="about us vdo"
                                    />
                                    <div className='play_btn_holder' onClick={handlePlayClick}>
                                        <FontAwesomeIcon className='play_btn_icon' icon={faCirclePlay} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-8">
                                <div className="img_corder_holder">
                                    <div className='img_holder'>
                                        <img className="about_us_img"
                                            src={process.env.PUBLIC_URL + "/assets/images/home/about_us/about_us_img.png"}
                                            alt="about us img" />
                                    </div>
                                    <div className="lefttop"></div>
                                    <div className="leftbot"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Home_about_us;
